export interface Girl {
    id: number,
    name: string,
    profile: string,
    hobby: string,
    age: number,
    height: number,
    lover: number,
    locked: boolean,
    sleep: boolean,
}

export interface Play {
    id: number,
    gid: string,
    turn: number,
    name: string,
    lover: string,
}

export class Inc {
    static readonly defaultGirl = ()=>{
        const girl:Girl = {
            id: 0,
            name: "",
            profile: "",
            hobby: "",
            age: 0,
            height: 0,
            lover: 0,
            locked: true,
            sleep: true,
        }
        return girl;
    }
    static readonly defaultPlay = ()=>{
        const play:Play = {
            id: 0,
            gid: "",
            turn: 0,
            name: "",
            lover: "",
        }
        return play;
    }

}